import { MapPin } from 'lucide-react';

export function LocationPermissionPrompt() {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="mb-4 opacity-50">
        <MapPin size={48} className="text-[var(--color-muted)]" />
      </div>
      <h2 className="text-lg font-semibold text-[var(--color-text)] mb-2">
        Location Access Required
      </h2>
      <p className="text-sm text-[var(--color-muted)] max-w-sm leading-relaxed">
        Allow Bar Guide to access your location to find bars, specials, and events near you.
        Click the location icon in your browser's address bar to enable access.
      </p>
    </div>
  );
}
